import { render, staticRenderFns } from "./RaceGridSettings.vue?vue&type=template&id=058ff4c4&"
import script from "./RaceGridSettings.vue?vue&type=script&lang=js&"
export * from "./RaceGridSettings.vue?vue&type=script&lang=js&"
import style0 from "./RaceGridSettings.vue?vue&type=style&index=0&id=058ff4c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports